import { mdiAccountBoxMultiple } from '@mdi/js'

export default [
  {
    title: 'کاربران',
    icon: mdiAccountBoxMultiple,
    action: 'can_see_menu_user',
    resource: 'all',
    children: [
      {
        title: 'لیست کاربران',
        to: 'users',
        action: 'can_see_user_list',
        resource: 'all',
      },
      {
        title: 'استعلام موبایل و کارت',
        to: 'checking',
        action: 'can_see_user_detail',
        resource: 'all',
      },
      {
        title: 'بلاک لیست',
        to: 'user-black-list',
        action: 'can_see_and_edit_block_list',
        resource: 'all',
      },
      {
        title: 'لیست تماس ',
        to: 'user-call-list',
        action: 'can_see_and_edit_call_list',
        resource: 'all',
      },
      {
        title: 'لیست توکن‌ها',
        to: 'users-access-tokens',
        action: 'can_see_and_delete_access_token',
        resource: 'all',
      },
    ],
  },
]
